/* src/components/Button/Button.jsx */
import './Button.css'
import {useState} from "react";
import {trackEvent} from "../../analytics/gtm.js";

/**
 * Кнопка лендінга.
 *
 * @param {object} props
 * @param {'primary'|'secondary'} [props.variant='primary'] - Варіант 1 / Варіант 2
 * @param {'sm'|'lg'} [props.size='lg'] - 39px / 61px
 * @param {string} [props.as='button'] - 'button' або 'a'
 * @param {string} [props.href] - якщо as='a'
 * @param {string} [props.analyticsEvent] - назва події в dataLayer на клік
 * @param {object} [props.analyticsParams] - додаткові параметри події
 * @param {Function} [props.onClick]
 */
export function Button({
  variant = 'primary',
  size = 'lg',
  as = 'button',
  href,
  analyticsEvent,
  analyticsParams,
  onClick,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'btn',
    `btn--${variant}`,
    `btn--${size}`,
    className,
  ].filter(Boolean).join(' ')

  const handleClick = (e) => {
    if (analyticsEvent) {
      trackEvent(analyticsEvent, { variant, ...analyticsParams })
    }
    onClick?.(e)
  }

  if (as === 'a') {
    return (
      <a href={href} className={classes} onClick={handleClick} {...rest}>
        {children}
      </a>
    )
  }

  return (
    <button type="button" className={classes} onClick={handleClick} {...rest}>
      {children}
    </button>
  )
}

/**
 * Кнопка-«тап» з hand.svg — використовується тільки в Products (мобілка).
 *
 * Стан 1: квадрат 40×40 з іконкою 24×24, без тексту.
 * Перший тап: кнопка з анімацією розгортається вправо, з'являється текст.
 * Другий тап: перехід за href (поки порожній — переходу нема).
 *
 * @param {object} props
 * @param {string} [props.href] - URL переходу на другий тап
 * @param {string} [props.analyticsEvent]
 * @param {object} [props.analyticsParams]
 */
export function HandButton({
  href = '',
  children = 'Детальніше',
  analyticsEvent,
  analyticsParams,
  onClick,
  className = '',
  ...rest
}) {
  const [expanded, setExpanded] = useState(false)

  const handleClick = (e) => {
    if (analyticsEvent) {
      trackEvent(analyticsEvent, { expanded, ...analyticsParams })
    }
    onClick?.(e)

    if (!expanded) {
      setExpanded(true)
      return
    }
    if (href) window.open(href, '_blank', 'noopener,noreferrer')
  }

  const classes = [
    'btn-hand',
    expanded ? 'is-expanded' : '',
    className,
  ].filter(Boolean).join(' ')

  return (
    <button type="button" className={classes} onClick={handleClick} aria-expanded={expanded} {...rest}>
      <img src="/icons/hand.svg" alt="" width="24" height="24" />
      <span className="btn-hand__label">{children}</span>
    </button>
  )
}
